import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.25 6.75H6.75V11.25H5.25V6.75H0.75V5.25H5.25V0.75H6.75V5.25H11.25V6.75Z",
		fill: "#E8EAED"
	})
});
export { SvgAddIcon as ReactComponent };
